import { FC } from "react";
import { useDeviceHook } from "../../utils/hooks/useDeviceHook";
import { NewRequisitionType } from "../NewRequisition/types";
import { TableModal } from "../shared/Modal/TableModal";
import { themePalette } from "../../theme";
import {
  RedrawFooter,
  RedrawMessage,
  RedrawTableView,
  useRedrawTableState,
} from "./RedrawTableShared";

interface RedrawModalProps {
  open: boolean;
  onClose: () => void;
  redrawDrafts: NewRequisitionType[];
  onViewOrders: () => void;
  onRowClick: (patientName: string) => void;
  onEditOrder?: (order: NewRequisitionType) => void;
}

export const RedrawModal: FC<RedrawModalProps> = ({
  open,
  onClose,
  redrawDrafts,
  onViewOrders,
  onRowClick,
  onEditOrder,
}) => {
  const { deviceType } = useDeviceHook();
  const state = useRedrawTableState({
    redrawDrafts,
    onRowClick,
    resetSignal: open,
  });

  const handleClose = () => {
    if (state.isBusy) return;
    onClose();
  };

  return (
    <TableModal
      open={open}
      onClose={handleClose}
      title={`REDRAWS (${state.pendingOrders.length})`}
      titleColor={themePalette.blueDark}
      message={<RedrawMessage />}
      footer={<RedrawFooter state={state} onViewOrders={onViewOrders} />}
      deviceType={deviceType}
    >
      <RedrawTableView
        redrawDrafts={redrawDrafts}
        state={state}
        onEditOrder={onEditOrder}
      />
    </TableModal>
  );
};
